import { Component, OnInit, EventEmitter, Output } from "@angular/core";
import { AuthenticationService } from "src/app/services/authentication.service";
import { IUser } from "src/app/interface/user";
import { SolutionAdminComponent } from "./solution-admin/solution-admin.component";
import { UserComponent } from "./user/user.component";
import { NgIf } from "@angular/common";
@Component({
    selector: "sms-help-center",
    templateUrl: "./help-center.component.html",
    styleUrls: ["./help-center.component.scss"],
    standalone: true,
    imports: [NgIf, UserComponent, SolutionAdminComponent]
})
export class HelpCenterComponent implements OnInit {
  currentUser: IUser;
  showAdmin = false;
  @Output() closeHelpCenterEvent = new EventEmitter();
  constructor(private authenticationService: AuthenticationService) {
    this.currentUser = this.authenticationService.currentUserValue;

    if (this.currentUser.roleId == 1) {
      this.showAdmin = true;
    }
  }
  ngOnInit(): void {
    // console.log("init help center component")
  }
  /**Close Help Center Popup */
  closeHelpCenterBuilder() {
    this.closeHelpCenterEvent.emit(false);
  }
}
